import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/lang";
import { fadeUp, stagger } from "./constants";

/**
 * Featured tours grid — shows up to 6 curated tours coming from GET /public/tours.
 */
export default function ToursSection({ tours, lang }) {
  const { t } = useLang();
  return (
    <motion.section
      id="tours"
      className="dt-section"
      data-testid="tours-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      variants={stagger}
    >
      <motion.p className="dt-section__eyebrow" variants={fadeUp}>{t("landing_tours_eyebrow")}</motion.p>
      <motion.h2 className="dt-section__title" variants={fadeUp}>{t("landing_tours_title")}</motion.h2>
      <motion.p className="dt-section__desc" variants={fadeUp}>{t("landing_tours_desc")}</motion.p>
      <motion.div className="dt-grid" variants={stagger}>
        {tours.slice(0, 6).map((tour) => {
          const tr = (tour.translations || []).find((x) => x.lang === lang)
            || (tour.translations || []).find((x) => x.lang === "PT")
            || {};
          const img = tour.cover_image || (tour.images || [])[0] || "/images/hero-lisbon.png";
          const price = tour.price_from_eur || tour.price_base ||
            (tour.vehicle_pricing || []).reduce(
              (min, r) => (r.price_eur > 0 && (min === 0 || r.price_eur < min) ? r.price_eur : min),
              0
            );
          return (
            <motion.article
              key={tour.id}
              className="dt-card"
              data-testid={`tour-card-${tour.slug}`}
              variants={fadeUp}
            >
              <div className="dt-card__imgwrap">
                <img src={img} alt={tr.title || tour.slug} className="dt-card__img" loading="lazy" />
                <span className="dt-card__zone-pill">{tour.zone || "Portugal"}</span>
              </div>
              <div className="dt-card__body">
                <div className="dt-card__meta">{tour.duration_hours}h · {t("landing_tour_private")}</div>
                <h3 className="dt-card__title">{tr.title || tour.slug}</h3>
                <p className="dt-card__desc">{(tr.short_description || "").slice(0, 120)}</p>
                <div className="dt-card__foot">
                  <div className="dt-card__price">
                    €{Math.round(price || 0)}<small>{t("landing_tour_from")}</small>
                  </div>
                  <Link to={`/login`} className="dt-card__cta" data-testid={`tour-cta-${tour.slug}`}>
                    {t("landing_tour_book")} <ArrowRight size={13} />
                  </Link>
                </div>
              </div>
            </motion.article>
          );
        })}
      </motion.div>
    </motion.section>
  );
}
